import * as React from 'react'
import { cn } from '@/lib/utils'

export interface ChartConfig {
  [key: string]: {
    label: string
    color: string
  }
}

interface ChartContainerProps {
  config: ChartConfig
  className?: string
  children: React.ReactNode
}

export function ChartContainer({
  config,
  className,
  children,
}: ChartContainerProps) {
  return <div className={cn('w-full', className)}>{children}</div>
}
